// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MemberGroup-module__font-s-10___ZRihE {
  font-size: 10px !important;
}

.MemberGroup-module__font-s-12___ac0xY {
  font-size: 12px !important;
}

.MemberGroup-module__font-s-13___vU2Le {
  font-size: 13px !important;
}

.MemberGroup-module__font-s-14___JD1Us {
  font-size: 14px !important;
}

.MemberGroup-module__font-s-15___Se7eS {
  font-size: 15px !important;
}

.MemberGroup-module__font-s-16___n7Sne {
  font-size: 16px !important;
}

.MemberGroup-module__font-s-18___n7Oss {
  font-size: 18px !important;
}

.MemberGroup-module__font-s-20___PAYW6 {
  font-size: 20px !important;
}

.MemberGroup-module__font-s-22____VOEz {
  font-size: 22px !important;
}

.MemberGroup-module__font-s-28___DIzfX {
  font-size: 28px !important;
}

.MemberGroup-module__font-w-400___PCGjC {
  font-weight: 400 !important;
}

.MemberGroup-module__font-w-500___hmwsq {
  font-weight: 500 !important;
}

.MemberGroup-module__font-w-600___bQAvq {
  font-weight: 600 !important;
}

.MemberGroup-module__font-w-700___HAAQp {
  font-weight: 700 !important;
}

.MemberGroup-module__p-5____i6EI {
  padding: 5px !important;
}

.MemberGroup-module__p-12___yAG9p {
  padding: 12px !important;
}

.MemberGroup-module__p-16___Aj4NS {
  padding: 16px !important;
}

.MemberGroup-module__p-30___SK4lz {
  padding: 30px !important;
}

.MemberGroup-module__p-b-0___kOzAr {
  padding-bottom: 0 !important;
}

.MemberGroup-module__p-b-5___GyvrG {
  padding-bottom: 5px !important;
}

.MemberGroup-module__p-b-10___HMQb7 {
  padding-bottom: 10px !important;
}

.MemberGroup-module__p-b-12____zpnp {
  padding-bottom: 12px !important;
}

.MemberGroup-module__p-b-16___bpJhE {
  padding-bottom: 16px !important;
}

.MemberGroup-module__p-b-18___TPGzT {
  padding-bottom: 18px !important;
}

.MemberGroup-module__p-b-20___rlh3p {
  padding-bottom: 20px !important;
}

.MemberGroup-module__p-b-25___waBVL {
  padding-bottom: 25px !important;
}

.MemberGroup-module__p-b-30___gNzMK {
  padding-bottom: 30px !important;
}

.MemberGroup-module__p-b-50___eaTpE {
  padding-bottom: 50px !important;
}

.MemberGroup-module__p-t-0___YvBPq {
  padding-top: 0 !important;
}

.MemberGroup-module__p-t-12___yGdPR {
  padding-top: 12px !important;
}

.MemberGroup-module__p-t-16____LdOE {
  padding-top: 16px !important;
}

.MemberGroup-module__p-t-18___ZxZla {
  padding-top: 18px !important;
}

.MemberGroup-module__p-t-20___ZxHNR {
  padding-top: 20px !important;
}

.MemberGroup-module__p-t-30___KPB4g {
  padding-top: 30px !important;
}

.MemberGroup-module__p-t-40___q3Inp {
  padding-top: 40px !important;
}

.MemberGroup-module__p-t-50___MIz2o {
  padding-top: 50px !important;
}

.MemberGroup-module__p-l-20___JTy_J {
  padding-left: 20px !important;
}

.MemberGroup-module__p-l-30___lhttc {
  padding-left: 30px !important;
}

.MemberGroup-module__p-l-40___Oit71 {
  padding-left: 40px !important;
}

.MemberGroup-module__p-r-16___BSL77 {
  padding-right: 16px !important;
}

.MemberGroup-module__p-r-20___AvxKb {
  padding-right: 20px !important;
}

.MemberGroup-module__p-r-30___jloDq {
  padding-right: 30px !important;
}

.MemberGroup-module__p-r-50___xzR5h {
  padding-right: 50px !important;
}

.MemberGroup-module__p-r-60___wI3bR {
  padding-right: 60px !important;
}

.MemberGroup-module__m-b-1____W4hL {
  margin-bottom: 1px !important;
}

.MemberGroup-module__m-b-2___mIWSa {
  margin-bottom: 2px !important;
}

.MemberGroup-module__m-b-6___Oy3bF {
  margin-bottom: 6px !important;
}

.MemberGroup-module__m-b-8___eeXi5 {
  margin-bottom: 8px !important;
}

.MemberGroup-module__m-b-10___b9Nae {
  margin-bottom: 10px !important;
}

.MemberGroup-module__m-b-14___f_QYB {
  margin-bottom: 14px !important;
}

.MemberGroup-module__m-b-16___dX9Oz {
  margin-bottom: 16px !important;
}

.MemberGroup-module__m-b-20____LerC {
  margin-bottom: 20px !important;
}

.MemberGroup-module__m-b-22___pfpTn {
  margin-bottom: 22px !important;
}

.MemberGroup-module__m-b-24___S3oH8 {
  margin-bottom: 24px !important;
}

.MemberGroup-module__m-b-30___APkAy {
  margin-bottom: 30px !important;
}

.MemberGroup-module__m-b-32___BcsyZ {
  margin-bottom: 32px !important;
}

.MemberGroup-module__m-b-40___dNKkH {
  margin-bottom: 40px !important;
}

.MemberGroup-module__m-t-2___GZ6GY {
  margin-top: 2px !important;
}

.MemberGroup-module__m-t-3___F4mak {
  margin-top: 3px !important;
}

.MemberGroup-module__m-t-4___FKSlv {
  margin-top: 4px !important;
}

.MemberGroup-module__m-t-5___cfvdL {
  margin-top: 5px !important;
}

.MemberGroup-module__m-t-8___Ez0kn {
  margin-top: 8px !important;
}

.MemberGroup-module__m-t-10___nVT2E {
  margin-top: 10px !important;
}

.MemberGroup-module__m-t-15___txSWo {
  margin-top: 15px !important;
}

.MemberGroup-module__m-t-16___oeOOM {
  margin-top: 16px !important;
}

.MemberGroup-module__m-t-20___EQGEp {
  margin-top: 20px !important;
}

.MemberGroup-module__m-t-22___yFzwl {
  margin-top: 22px !important;
}

.MemberGroup-module__m-t-30___PYbcO {
  margin-top: 30px !important;
}

.MemberGroup-module__m-t-32___KVeZ3 {
  margin-top: 32px !important;
}

.MemberGroup-module__m-l-auto___l3aKI {
  margin-left: auto !important;
}

.MemberGroup-module__m-l-4___YFknH {
  margin-left: 4px !important;
}

.MemberGroup-module__m-l-5___iZeu4 {
  margin-left: 5px !important;
}

.MemberGroup-module__m-l-6___GRgwl {
  margin-left: 6px !important;
}

.MemberGroup-module__m-l-8___tJHXX {
  margin-left: 8px !important;
}

.MemberGroup-module__m-l-10___stZUu {
  margin-left: 10px !important;
}

.MemberGroup-module__m-l-16___qwsbf {
  margin-left: 16px !important;
}

.MemberGroup-module__m-l-20___rbY2X {
  margin-left: 20px !important;
}

.MemberGroup-module__m-l-24___AbEhz {
  margin-left: 24px !important;
}

.MemberGroup-module__m-l-30___bxiGZ {
  margin-left: 30px !important;
}

.MemberGroup-module__m-l-35___wrfHM {
  margin-left: 35px !important;
}

.MemberGroup-module__m-l-40___MqWEj {
  margin-left: 40px !important;
}

.MemberGroup-module__m-r-8___zyeSp {
  margin-right: 8px !important;
}

.MemberGroup-module__m-r-10___deXQi {
  margin-right: 10px !important;
}

.MemberGroup-module__m-r-16___mqYhw {
  margin-right: 16px !important;
}

.MemberGroup-module__m-r-20___vdKnr {
  margin-right: 20px !important;
}

.MemberGroup-module__m-r-24___AdABL {
  margin-right: 24px !important;
}

.MemberGroup-module__m-r-30___SzLZ_ {
  margin-right: 30px !important;
}

.MemberGroup-module__m-r-40___EBa8O {
  margin-right: 40px !important;
}

.MemberGroup-module__border-r-3___wXrhw {
  border-radius: 3px !important;
}

.MemberGroup-module__border-r-4___jUnvA {
  border-radius: 4px !important;
}

.MemberGroup-module__border-r-6___dTvRe {
  border-radius: 6px !important;
}

.MemberGroup-module__border-r-10___F2HSZ {
  border-radius: 10px !important;
}

.MemberGroup-module__border-r-12___HE_MU {
  border-radius: 12px !important;
}

.MemberGroup-module__border-r-16___hc8Jk {
  border-radius: 16px !important;
}

.MemberGroup-module__border-r-50___eVhZU {
  border-radius: 50% !important;
}

.MemberGroup-module__primary-border___GfV1S {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MemberGroup-module__primary-border-b___dflXM {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MemberGroup-module__primary-border-t___b0H3w {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MemberGroup-module__primary-border-l___w0XNc {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MemberGroup-module__primary-border-r___YtWmi {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MemberGroup-module__secondary-border___oM8Wb {
  border: 1px solid #637768;
}

.MemberGroup-module__secondary-border-b___bs_sT {
  border-bottom: 1px solid #637768;
}

.MemberGroup-module__secondary-border-t___oJWG1 {
  border-top: 1px solid #637768;
}

.MemberGroup-module__secondary-border-l___F6_0i {
  border-left: 1px solid #637768;
}

.MemberGroup-module__secondary-border-r___SYgsx {
  border-right: 1px solid #637768;
}

.MemberGroup-module__gap-0___TQGL0 {
  gap: 0 !important;
}

.MemberGroup-module__gap-2___mhPVz {
  gap: 2px !important;
}

.MemberGroup-module__gap-4___rVEz4 {
  gap: 4px !important;
}

.MemberGroup-module__gap-5___cp0Da {
  gap: 5px !important;
}

.MemberGroup-module__gap-6___CoRW7 {
  gap: 6px !important;
}

.MemberGroup-module__gap-8___bXrdR {
  gap: 8px !important;
}

.MemberGroup-module__gap-10___OvO5U {
  gap: 10px !important;
}

.MemberGroup-module__gap-12___qnWBn {
  gap: 12px !important;
}

.MemberGroup-module__gap-14___o1s_w {
  gap: 14px !important;
}

.MemberGroup-module__gap-16___qlzRn {
  gap: 16px !important;
}

.MemberGroup-module__gap-18___ex5Sw {
  gap: 18px !important;
}

.MemberGroup-module__gap-20___phNSK {
  gap: 20px !important;
}

.MemberGroup-module__gap-24___YVHz5 {
  gap: 24px !important;
}

.MemberGroup-module__gap-26____FnWt {
  gap: 26px !important;
}

.MemberGroup-module__gap-30___Y4uK2 {
  gap: 30px !important;
}

.MemberGroup-module__gap-32___Y1DGq {
  gap: 32px !important;
}

.MemberGroup-module__gap-40___AME4j {
  gap: 40px !important;
}

.MemberGroup-module__gap-50___ivpVe {
  gap: 50px !important;
}

.MemberGroup-module__flex-1___OjRlJ {
  flex: 1;
}

.MemberGroup-module__flex-none___RVbyS {
  flex: none !important;
}

.MemberGroup-module__flex-column___vIHTI {
  display: flex;
  flex-direction: column !important;
}

.MemberGroup-module__flex-row___OGsrp {
  display: flex;
  flex-direction: row !important;
}

.MemberGroup-module__vertically-centered___RMHZX {
  display: flex;
  align-items: center !important;
}

.MemberGroup-module__horizontally-centered____8kuT {
  display: flex;
  justify-content: center !important;
}

.MemberGroup-module__horizontally-end___sYBnp {
  display: flex;
  justify-content: end !important;
}

.MemberGroup-module__vertically-start___ysFEG {
  display: flex;
  align-items: start !important;
}

.MemberGroup-module__space-between___ueaB1 {
  display: flex;
  justify-content: space-between !important;
}

.MemberGroup-module__flex-wrap___ckhFm {
  flex-wrap: wrap !important;
}

.MemberGroup-module__height-100___MCwfM {
  height: 100%;
}

.MemberGroup-module__width-50____2Xu0 {
  width: 50% !important;
}

.MemberGroup-module__width-100___yl2As {
  width: 100%;
}

.MemberGroup-module__cursor-pointer___6c2TW {
  cursor: pointer;
}

.MemberGroup-module__cursor-not-allowed___sa_XM {
  cursor: not-allowed !important;
}

.MemberGroup-module__absolute-centered___HFVlD {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MemberGroup-module__absolute___NPlCi {
  position: absolute;
}

.MemberGroup-module__relative___emqon {
  position: relative;
}

.MemberGroup-module__fixed___pJ2Fc {
  position: fixed;
}

.MemberGroup-module__visible___pONwN {
  opacity: 1;
}

.MemberGroup-module__invisible___V2sVv {
  opacity: 0;
}

.MemberGroup-module__col-90___DKj6P {
  width: 90% !important;
}

.MemberGroup-module__col-auto___dvzQ0 {
  width: auto !important;
}

.MemberGroup-module__medical-tabs___EzaXV {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MemberGroup-module__medical-table-new___lx1Eo {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MemberGroup-module__medical-table-new___lx1Eo:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MemberGroup-module__medical-table-new___lx1Eo::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MemberGroup-module__medical-table-new___lx1Eo::-webkit-scrollbar-track {
  display: none;
}
.MemberGroup-module__medical-table-new___lx1Eo.MemberGroup-module__no-pagination___dr5lq {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MemberGroup-module__medical-table-new___lx1Eo.MemberGroup-module__no-pagination___dr5lq:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MemberGroup-module__medical-table-new___lx1Eo.MemberGroup-module__no-pagination___dr5lq::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MemberGroup-module__medical-table-new___lx1Eo.MemberGroup-module__no-pagination___dr5lq::-webkit-scrollbar-track {
  display: none;
}

.MemberGroup-module__medical-table-empty___zw2c3 {
  padding: 14px 40px !important;
}

.MemberGroup-module__icon-btn___pOiOh {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MemberGroup-module__search-icon___pxGBb {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MemberGroup-module__disable-select___q5PGp {
  user-select: none;
}

.MemberGroup-module__break-word___nffar {
  word-break: break-word;
}

.MemberGroup-module__popup-clear-btn___XzSll {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MemberGroup-module__scroll-m-b-20___OyZCw {
  scroll-margin-bottom: 20px;
}

.MemberGroup-module__memberHeader____8Cfv {
  display: flex;
  align-items: stretch;
  padding: 0 14px;
  border-bottom: 1px solid #f4f4f5;
  background: rgba(250, 250, 250, 0.6);
}

.MemberGroup-module__memberHeader____8Cfv > span {
  padding-top: 5px;
  padding-bottom: 5px;
}

.MemberGroup-module__memberLead___HxHiA {
  display: flex;
  width: 31px;
  flex-shrink: 0;
  align-items: center;
  align-self: center;
  gap: 10px;
}

.MemberGroup-module__memberHeaderMember___SbV2I {
  width: 15rem;
  flex-shrink: 0;
  padding-left: 10px;
  padding-right: 16px;
}

.MemberGroup-module__hairlineCell___H7Aiw {
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  padding: 10px 16px;
  border-left: 1px solid #e4e4e7;
}

.MemberGroup-module__visitCell___wK9hm {
  width: 17rem;
  min-width: 13rem;
  flex-shrink: 1;
}

.MemberGroup-module__teamCell___OAXC6 {
  display: none;
  width: 15rem;
  flex-shrink: 0;
}

@container (min-width: 1000px) {
  .MemberGroup-module__teamCell___OAXC6 {
    display: flex;
  }
}
.MemberGroup-module__tasksCell___iiRgD {
  flex: 1;
}

.MemberGroup-module__dueColumn___L3Wlb {
  width: 6rem;
  flex-shrink: 0;
  align-items: center;
  text-align: center;
}

.MemberGroup-module__memberRow___XJA0r {
  display: flex;
  align-items: stretch;
  padding: 0 14px;
  background: #ffffff;
  cursor: pointer;
  transition: background-color 0.15s;
  outline: none;
}
.MemberGroup-module__memberRow___XJA0r:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.MemberGroup-module__memberRow___XJA0r:hover {
  background: #fafafa;
}

.MemberGroup-module__memberRowOpen___HRS5j,
.MemberGroup-module__memberRowOpen___HRS5j:hover {
  background: #fafafa;
}

.MemberGroup-module__memberChevron___OqxGK {
  flex-shrink: 0;
  color: #a1a1aa;
  transition: transform 0.15s;
}

.MemberGroup-module__memberChevronOpen___pZDPs {
  transform: rotate(90deg);
}

.MemberGroup-module__urgencyBar___GqyEb {
  width: 3px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 2px;
  background: #d4d4d8;
}

.MemberGroup-module__urgencynow___rwtZD {
  background: #18181b;
}

.MemberGroup-module__urgencyheld___fHFCx,
.MemberGroup-module__urgencysoon___cbWAi {
  background: #71717a;
}

.MemberGroup-module__urgencyescalated___E5dUV {
  background: #eab308;
}

.MemberGroup-module__urgencylater___uHx_N {
  background: #d4d4d8;
}

.MemberGroup-module__memberCell____5a2N {
  width: 15rem;
  flex-shrink: 0;
  padding: 10px 16px 10px 10px;
}

.MemberGroup-module__memberNameLine___hMuTf {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 8px;
}

.MemberGroup-module__memberName___DZis8 {
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
}

.MemberGroup-module__memberMrn___z6uQt {
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  color: #a1a1aa;
}

.MemberGroup-module__memberPhase___MmXCw {
  margin-top: 3px;
  font-size: 13px;
  color: #71717a;
}

.MemberGroup-module__visitLine___kSz5U {
  display: grid;
  grid-template-columns: 2.5rem minmax(0, 1fr);
  column-gap: 8px;
  align-items: center;
  min-width: 0;
}

.MemberGroup-module__visitMark___ff6r4 {
  display: flex;
  grid-row: span 2;
  align-items: center;
}

.MemberGroup-module__visitName___RbGHY {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.5;
  color: #18181b;
}

.MemberGroup-module__visitWhen___zvIvW {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  color: #71717a;
}

.MemberGroup-module__noVisit___Qj2v_ {
  font-size: 13px;
  color: #a1a1aa;
}

.MemberGroup-module__countBadges____mQTO {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.MemberGroup-module__nowLater___pX5Tm {
  display: inline-flex;
  overflow: hidden;
  border: 1px solid #e4e4e7;
  border-radius: 4px;
}

.MemberGroup-module__nowPart___PZQLP,
.MemberGroup-module__laterPart____pQfr {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  background: #f4f4f5;
}

.MemberGroup-module__nowPartOn___zqKYS {
  background: #18181b;
}

.MemberGroup-module__nowNumber___IZcYB,
.MemberGroup-module__laterNumber___xLe6q {
  font-family: "IBM Plex Mono", monospace;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  color: #a1a1aa;
}

.MemberGroup-module__nowPartOn___zqKYS .MemberGroup-module__nowNumber___IZcYB {
  color: #fafafa;
}

.MemberGroup-module__laterNumber___xLe6q {
  color: #71717a;
}

.MemberGroup-module__nowWord___HvIrc,
.MemberGroup-module__laterWord___PWPUj {
  font-size: 11px;
  color: #d4d4d8;
}

.MemberGroup-module__nowPartOn___zqKYS .MemberGroup-module__nowWord___HvIrc {
  color: #a1a1aa;
}

.MemberGroup-module__laterWord___PWPUj {
  color: #71717a;
}

.MemberGroup-module__dueColumn___L3Wlb {
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  font-weight: 400;
  white-space: nowrap;
  color: #a1a1aa;
}

.MemberGroup-module__dueColumnUrgent___F3kvg {
  font-weight: 600;
  color: #18181b;
}

.MemberGroup-module__bucketIndexoverdue___pPWXW,
.MemberGroup-module__bucketIndexpriority___Yb9FA,
.MemberGroup-module__bucketIndexfuture___w4GVj {
  display: inline-flex;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  font-weight: 800;
  color: #ffffff;
}

.MemberGroup-module__bucketIndexoverdue___pPWXW {
  background: #991b1b;
}

.MemberGroup-module__bucketIndexpriority___Yb9FA {
  background: #18181b;
}

.MemberGroup-module__bucketIndexfuture___w4GVj {
  border: 1.5px solid #d4d4d8;
  background: #ffffff;
  font-weight: 700;
  color: #a1a1aa;
}

.MemberGroup-module__bucketLabeloverdue___IX4kj {
  color: #991b1b;
}

.MemberGroup-module__bucketLabelpriority___QDuKf {
  color: #18181b;
}

.MemberGroup-module__memberRow___XJA0r,
.MemberGroup-module__memberHeader____8Cfv {
  line-height: 1.5;
}

.MemberGroup-module__countBadge___eXufs {
  font-size: 13px;
  line-height: 22px;
  padding: 0 8px;
}

.MemberGroup-module__memberPhase___MmXCw,
.MemberGroup-module__memberMrn___z6uQt,
.MemberGroup-module__visitWhen___zvIvW,
.MemberGroup-module__noVisit___Qj2v_ {
  line-height: 1.4286;
}

.MemberGroup-module__bucketHeader___ylt7i {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px 3px;
}

.MemberGroup-module__bucketCount___RYDRf {
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  font-weight: 600;
  color: #52525b;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/MemberGroup/MemberGroup.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,oBAAA;EACA,eAAA;EACA,gCAAA;EACA,oCAAA;AA8pBF;;AA3pBA;EACE,gBAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AA8pBF;;AA3pBA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AA8pBF;;AA3pBA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,YAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE;IACE,aAAA;EA8pBF;AACF;AA3pBA;EACE,OAAA;AA6pBF;;AA1pBA;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;EErCA,aAAA;AFmsBF;AEjsBE;EACE,0BAAA;EACA,mBALuB;AFwsB3B;AA/pBE;EACE,mBAAA;AAiqBJ;;AA7pBA;;EAEE,mBAAA;AAgqBF;;AA7pBA;EACE,cAAA;EACA,cAAA;EACA,2BAAA;AAgqBF;;AA7pBA;EACE,wBAAA;AAgqBF;;AA7pBA;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAgqBF;;AA7pBA;EACE,mBAAA;AAgqBF;;AA7pBA;;EAEE,mBAAA;AAgqBF;;AA7pBA;EACE,mBAAA;AAgqBF;;AA7pBA;EACE,mBAAA;AAgqBF;;AA7pBA;EACE,YAAA;EACA,cAAA;EACA,4BAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;AAgqBF;;AA7pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,4CAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;AAgqBF;;AA7pBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,eAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AAgqBF;;AA7pBA;EACE,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAgqBF;;AA7pBA;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AAgqBF;;AA7pBA;EACE,mBAAA;AAgqBF;;AA7pBA;;EAEE,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,cAAA;AAgqBF;;AA7pBA;EACE,cAAA;AAgqBF;;AA7pBA;;EAEE,eAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,cAAA;AAgqBF;;AA7pBA;EACE,cAAA;AAgqBF;;AA7pBA;EACE,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,gBAAA;EACA,cAAA;AAgqBF;;AA7pBA;;;EAGE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,mBAAA;AAgqBF;;AA7pBA;EACE,mBAAA;AAgqBF;;AA7pBA;EACE,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,cAAA;AAgqBF;;AA7pBA;EACE,cAAA;AAgqBF;;AA7pBA;;EAEE,gBAAA;AAgqBF;;AA7pBA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAgqBF;;AA7pBA;;;;EAIE,mBAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;AAgqBF;;AA7pBA;EACE,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAgqBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.memberHeader {\n  display: flex;\n  align-items: stretch;\n  padding: 0 14px;\n  border-bottom: 1px solid #f4f4f5;\n  background: rgba(250, 250, 250, 0.6);\n}\n\n.memberHeader > span {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.memberLead {\n  display: flex;\n  width: 31px;\n  flex-shrink: 0;\n  align-items: center;\n  align-self: center;\n  gap: 10px;\n}\n\n.memberHeaderMember {\n  width: 15rem;\n  flex-shrink: 0;\n  padding-left: 10px;\n  padding-right: 16px;\n}\n\n.hairlineCell {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  justify-content: center;\n  align-self: stretch;\n  padding: 10px 16px;\n  border-left: 1px solid #e4e4e7;\n}\n\n.visitCell {\n  width: 17rem;\n  min-width: 13rem;\n  flex-shrink: 1;\n}\n\n.teamCell {\n  display: none;\n  width: 15rem;\n  flex-shrink: 0;\n}\n\n@container (min-width: 1000px) {\n  .teamCell {\n    display: flex;\n  }\n}\n\n.tasksCell {\n  flex: 1;\n}\n\n.dueColumn {\n  width: 6rem;\n  flex-shrink: 0;\n  align-items: center;\n  text-align: center;\n}\n\n.memberRow {\n  display: flex;\n  align-items: stretch;\n  padding: 0 14px;\n  background: #ffffff;\n  cursor: pointer;\n  transition: background-color 0.15s;\n  @include focus-ring;\n\n  &:hover {\n    background: #fafafa;\n  }\n}\n\n.memberRowOpen,\n.memberRowOpen:hover {\n  background: #fafafa;\n}\n\n.memberChevron {\n  flex-shrink: 0;\n  color: #a1a1aa;\n  transition: transform 0.15s;\n}\n\n.memberChevronOpen {\n  transform: rotate(90deg);\n}\n\n.urgencyBar {\n  width: 3px;\n  height: 28px;\n  flex-shrink: 0;\n  border-radius: 2px;\n  background: #d4d4d8;\n}\n\n.urgencynow {\n  background: #18181b;\n}\n\n.urgencyheld,\n.urgencysoon {\n  background: #71717a;\n}\n\n.urgencyescalated {\n  background: #eab308;\n}\n\n.urgencylater {\n  background: #d4d4d8;\n}\n\n.memberCell {\n  width: 15rem;\n  flex-shrink: 0;\n  padding: 10px 16px 10px 10px;\n}\n\n.memberNameLine {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0 8px;\n}\n\n.memberName {\n  font-size: 15px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.memberMrn {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.memberPhase {\n  margin-top: 3px;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.visitLine {\n  display: grid;\n  grid-template-columns: 2.5rem minmax(0, 1fr);\n  column-gap: 8px;\n  align-items: center;\n  min-width: 0;\n}\n\n.visitMark {\n  display: flex;\n  grid-row: span 2;\n  align-items: center;\n}\n\n.visitName {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #18181b;\n}\n\n.visitWhen {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  font-variant-numeric: tabular-nums;\n  color: #71717a;\n}\n\n.noVisit {\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.countBadges {\n  display: flex;\n  min-width: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.nowLater {\n  display: inline-flex;\n  overflow: hidden;\n  border: 1px solid #e4e4e7;\n  border-radius: 4px;\n}\n\n.nowPart,\n.laterPart {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 7px;\n  background: #f4f4f5;\n}\n\n.nowPartOn {\n  background: #18181b;\n}\n\n.nowNumber,\n.laterNumber {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1;\n  color: #a1a1aa;\n}\n\n.nowPartOn .nowNumber {\n  color: #fafafa;\n}\n\n.laterNumber {\n  color: #71717a;\n}\n\n.nowWord,\n.laterWord {\n  font-size: 11px;\n  color: #d4d4d8;\n}\n\n.nowPartOn .nowWord {\n  color: #a1a1aa;\n}\n\n.laterWord {\n  color: #71717a;\n}\n\n.dueColumn {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  font-weight: 400;\n  white-space: nowrap;\n  color: #a1a1aa;\n}\n\n.dueColumnUrgent {\n  font-weight: 600;\n  color: #18181b;\n}\n\n.bucketIndexoverdue,\n.bucketIndexpriority,\n.bucketIndexfuture {\n  display: inline-flex;\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.bucketIndexoverdue {\n  background: #991b1b;\n}\n\n.bucketIndexpriority {\n  background: #18181b;\n}\n\n.bucketIndexfuture {\n  border: 1.5px solid #d4d4d8;\n  background: #ffffff;\n  font-weight: 700;\n  color: #a1a1aa;\n}\n\n.bucketLabeloverdue {\n  color: #991b1b;\n}\n\n.bucketLabelpriority {\n  color: #18181b;\n}\n\n.memberRow,\n.memberHeader {\n  line-height: 1.5;\n}\n\n.countBadge {\n  font-size: 13px;\n  line-height: 22px;\n  padding: 0 8px;\n}\n\n.memberPhase,\n.memberMrn,\n.visitWhen,\n.noVisit {\n  line-height: 1.4286;\n}\n\n.bucketHeader {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px 3px;\n}\n\n.bucketCount {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  font-weight: 600;\n  color: #52525b;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MemberGroup-module__font-s-10___ZRihE`,
	"fontS12": `MemberGroup-module__font-s-12___ac0xY`,
	"fontS13": `MemberGroup-module__font-s-13___vU2Le`,
	"fontS14": `MemberGroup-module__font-s-14___JD1Us`,
	"fontS15": `MemberGroup-module__font-s-15___Se7eS`,
	"fontS16": `MemberGroup-module__font-s-16___n7Sne`,
	"fontS18": `MemberGroup-module__font-s-18___n7Oss`,
	"fontS20": `MemberGroup-module__font-s-20___PAYW6`,
	"fontS22": `MemberGroup-module__font-s-22____VOEz`,
	"fontS28": `MemberGroup-module__font-s-28___DIzfX`,
	"fontW400": `MemberGroup-module__font-w-400___PCGjC`,
	"fontW500": `MemberGroup-module__font-w-500___hmwsq`,
	"fontW600": `MemberGroup-module__font-w-600___bQAvq`,
	"fontW700": `MemberGroup-module__font-w-700___HAAQp`,
	"p5": `MemberGroup-module__p-5____i6EI`,
	"p12": `MemberGroup-module__p-12___yAG9p`,
	"p16": `MemberGroup-module__p-16___Aj4NS`,
	"p30": `MemberGroup-module__p-30___SK4lz`,
	"pB0": `MemberGroup-module__p-b-0___kOzAr`,
	"pB5": `MemberGroup-module__p-b-5___GyvrG`,
	"pB10": `MemberGroup-module__p-b-10___HMQb7`,
	"pB12": `MemberGroup-module__p-b-12____zpnp`,
	"pB16": `MemberGroup-module__p-b-16___bpJhE`,
	"pB18": `MemberGroup-module__p-b-18___TPGzT`,
	"pB20": `MemberGroup-module__p-b-20___rlh3p`,
	"pB25": `MemberGroup-module__p-b-25___waBVL`,
	"pB30": `MemberGroup-module__p-b-30___gNzMK`,
	"pB50": `MemberGroup-module__p-b-50___eaTpE`,
	"pT0": `MemberGroup-module__p-t-0___YvBPq`,
	"pT12": `MemberGroup-module__p-t-12___yGdPR`,
	"pT16": `MemberGroup-module__p-t-16____LdOE`,
	"pT18": `MemberGroup-module__p-t-18___ZxZla`,
	"pT20": `MemberGroup-module__p-t-20___ZxHNR`,
	"pT30": `MemberGroup-module__p-t-30___KPB4g`,
	"pT40": `MemberGroup-module__p-t-40___q3Inp`,
	"pT50": `MemberGroup-module__p-t-50___MIz2o`,
	"pL20": `MemberGroup-module__p-l-20___JTy_J`,
	"pL30": `MemberGroup-module__p-l-30___lhttc`,
	"pL40": `MemberGroup-module__p-l-40___Oit71`,
	"pR16": `MemberGroup-module__p-r-16___BSL77`,
	"pR20": `MemberGroup-module__p-r-20___AvxKb`,
	"pR30": `MemberGroup-module__p-r-30___jloDq`,
	"pR50": `MemberGroup-module__p-r-50___xzR5h`,
	"pR60": `MemberGroup-module__p-r-60___wI3bR`,
	"mB1": `MemberGroup-module__m-b-1____W4hL`,
	"mB2": `MemberGroup-module__m-b-2___mIWSa`,
	"mB6": `MemberGroup-module__m-b-6___Oy3bF`,
	"mB8": `MemberGroup-module__m-b-8___eeXi5`,
	"mB10": `MemberGroup-module__m-b-10___b9Nae`,
	"mB14": `MemberGroup-module__m-b-14___f_QYB`,
	"mB16": `MemberGroup-module__m-b-16___dX9Oz`,
	"mB20": `MemberGroup-module__m-b-20____LerC`,
	"mB22": `MemberGroup-module__m-b-22___pfpTn`,
	"mB24": `MemberGroup-module__m-b-24___S3oH8`,
	"mB30": `MemberGroup-module__m-b-30___APkAy`,
	"mB32": `MemberGroup-module__m-b-32___BcsyZ`,
	"mB40": `MemberGroup-module__m-b-40___dNKkH`,
	"mT2": `MemberGroup-module__m-t-2___GZ6GY`,
	"mT3": `MemberGroup-module__m-t-3___F4mak`,
	"mT4": `MemberGroup-module__m-t-4___FKSlv`,
	"mT5": `MemberGroup-module__m-t-5___cfvdL`,
	"mT8": `MemberGroup-module__m-t-8___Ez0kn`,
	"mT10": `MemberGroup-module__m-t-10___nVT2E`,
	"mT15": `MemberGroup-module__m-t-15___txSWo`,
	"mT16": `MemberGroup-module__m-t-16___oeOOM`,
	"mT20": `MemberGroup-module__m-t-20___EQGEp`,
	"mT22": `MemberGroup-module__m-t-22___yFzwl`,
	"mT30": `MemberGroup-module__m-t-30___PYbcO`,
	"mT32": `MemberGroup-module__m-t-32___KVeZ3`,
	"mLAuto": `MemberGroup-module__m-l-auto___l3aKI`,
	"mL4": `MemberGroup-module__m-l-4___YFknH`,
	"mL5": `MemberGroup-module__m-l-5___iZeu4`,
	"mL6": `MemberGroup-module__m-l-6___GRgwl`,
	"mL8": `MemberGroup-module__m-l-8___tJHXX`,
	"mL10": `MemberGroup-module__m-l-10___stZUu`,
	"mL16": `MemberGroup-module__m-l-16___qwsbf`,
	"mL20": `MemberGroup-module__m-l-20___rbY2X`,
	"mL24": `MemberGroup-module__m-l-24___AbEhz`,
	"mL30": `MemberGroup-module__m-l-30___bxiGZ`,
	"mL35": `MemberGroup-module__m-l-35___wrfHM`,
	"mL40": `MemberGroup-module__m-l-40___MqWEj`,
	"mR8": `MemberGroup-module__m-r-8___zyeSp`,
	"mR10": `MemberGroup-module__m-r-10___deXQi`,
	"mR16": `MemberGroup-module__m-r-16___mqYhw`,
	"mR20": `MemberGroup-module__m-r-20___vdKnr`,
	"mR24": `MemberGroup-module__m-r-24___AdABL`,
	"mR30": `MemberGroup-module__m-r-30___SzLZ_`,
	"mR40": `MemberGroup-module__m-r-40___EBa8O`,
	"borderR3": `MemberGroup-module__border-r-3___wXrhw`,
	"borderR4": `MemberGroup-module__border-r-4___jUnvA`,
	"borderR6": `MemberGroup-module__border-r-6___dTvRe`,
	"borderR10": `MemberGroup-module__border-r-10___F2HSZ`,
	"borderR12": `MemberGroup-module__border-r-12___HE_MU`,
	"borderR16": `MemberGroup-module__border-r-16___hc8Jk`,
	"borderR50": `MemberGroup-module__border-r-50___eVhZU`,
	"primaryBorder": `MemberGroup-module__primary-border___GfV1S`,
	"primaryBorderB": `MemberGroup-module__primary-border-b___dflXM`,
	"primaryBorderT": `MemberGroup-module__primary-border-t___b0H3w`,
	"primaryBorderL": `MemberGroup-module__primary-border-l___w0XNc`,
	"primaryBorderR": `MemberGroup-module__primary-border-r___YtWmi`,
	"secondaryBorder": `MemberGroup-module__secondary-border___oM8Wb`,
	"secondaryBorderB": `MemberGroup-module__secondary-border-b___bs_sT`,
	"secondaryBorderT": `MemberGroup-module__secondary-border-t___oJWG1`,
	"secondaryBorderL": `MemberGroup-module__secondary-border-l___F6_0i`,
	"secondaryBorderR": `MemberGroup-module__secondary-border-r___SYgsx`,
	"gap0": `MemberGroup-module__gap-0___TQGL0`,
	"gap2": `MemberGroup-module__gap-2___mhPVz`,
	"gap4": `MemberGroup-module__gap-4___rVEz4`,
	"gap5": `MemberGroup-module__gap-5___cp0Da`,
	"gap6": `MemberGroup-module__gap-6___CoRW7`,
	"gap8": `MemberGroup-module__gap-8___bXrdR`,
	"gap10": `MemberGroup-module__gap-10___OvO5U`,
	"gap12": `MemberGroup-module__gap-12___qnWBn`,
	"gap14": `MemberGroup-module__gap-14___o1s_w`,
	"gap16": `MemberGroup-module__gap-16___qlzRn`,
	"gap18": `MemberGroup-module__gap-18___ex5Sw`,
	"gap20": `MemberGroup-module__gap-20___phNSK`,
	"gap24": `MemberGroup-module__gap-24___YVHz5`,
	"gap26": `MemberGroup-module__gap-26____FnWt`,
	"gap30": `MemberGroup-module__gap-30___Y4uK2`,
	"gap32": `MemberGroup-module__gap-32___Y1DGq`,
	"gap40": `MemberGroup-module__gap-40___AME4j`,
	"gap50": `MemberGroup-module__gap-50___ivpVe`,
	"flex1": `MemberGroup-module__flex-1___OjRlJ`,
	"flexNone": `MemberGroup-module__flex-none___RVbyS`,
	"flexColumn": `MemberGroup-module__flex-column___vIHTI`,
	"flexRow": `MemberGroup-module__flex-row___OGsrp`,
	"verticallyCentered": `MemberGroup-module__vertically-centered___RMHZX`,
	"horizontallyCentered": `MemberGroup-module__horizontally-centered____8kuT`,
	"horizontallyEnd": `MemberGroup-module__horizontally-end___sYBnp`,
	"verticallyStart": `MemberGroup-module__vertically-start___ysFEG`,
	"spaceBetween": `MemberGroup-module__space-between___ueaB1`,
	"flexWrap": `MemberGroup-module__flex-wrap___ckhFm`,
	"height100": `MemberGroup-module__height-100___MCwfM`,
	"width50": `MemberGroup-module__width-50____2Xu0`,
	"width100": `MemberGroup-module__width-100___yl2As`,
	"cursorPointer": `MemberGroup-module__cursor-pointer___6c2TW`,
	"cursorNotAllowed": `MemberGroup-module__cursor-not-allowed___sa_XM`,
	"absoluteCentered": `MemberGroup-module__absolute-centered___HFVlD`,
	"absolute": `MemberGroup-module__absolute___NPlCi`,
	"relative": `MemberGroup-module__relative___emqon`,
	"fixed": `MemberGroup-module__fixed___pJ2Fc`,
	"visible": `MemberGroup-module__visible___pONwN`,
	"invisible": `MemberGroup-module__invisible___V2sVv`,
	"col90": `MemberGroup-module__col-90___DKj6P`,
	"colAuto": `MemberGroup-module__col-auto___dvzQ0`,
	"medicalTabs": `MemberGroup-module__medical-tabs___EzaXV`,
	"medicalTableNew": `MemberGroup-module__medical-table-new___lx1Eo`,
	"noPagination": `MemberGroup-module__no-pagination___dr5lq`,
	"medicalTableEmpty": `MemberGroup-module__medical-table-empty___zw2c3`,
	"iconBtn": `MemberGroup-module__icon-btn___pOiOh`,
	"searchIcon": `MemberGroup-module__search-icon___pxGBb`,
	"disableSelect": `MemberGroup-module__disable-select___q5PGp`,
	"breakWord": `MemberGroup-module__break-word___nffar`,
	"popupClearBtn": `MemberGroup-module__popup-clear-btn___XzSll`,
	"scrollMB20": `MemberGroup-module__scroll-m-b-20___OyZCw`,
	"memberHeader": `MemberGroup-module__memberHeader____8Cfv`,
	"memberLead": `MemberGroup-module__memberLead___HxHiA`,
	"memberHeaderMember": `MemberGroup-module__memberHeaderMember___SbV2I`,
	"hairlineCell": `MemberGroup-module__hairlineCell___H7Aiw`,
	"visitCell": `MemberGroup-module__visitCell___wK9hm`,
	"teamCell": `MemberGroup-module__teamCell___OAXC6`,
	"tasksCell": `MemberGroup-module__tasksCell___iiRgD`,
	"dueColumn": `MemberGroup-module__dueColumn___L3Wlb`,
	"memberRow": `MemberGroup-module__memberRow___XJA0r`,
	"memberRowOpen": `MemberGroup-module__memberRowOpen___HRS5j`,
	"memberChevron": `MemberGroup-module__memberChevron___OqxGK`,
	"memberChevronOpen": `MemberGroup-module__memberChevronOpen___pZDPs`,
	"urgencyBar": `MemberGroup-module__urgencyBar___GqyEb`,
	"urgencynow": `MemberGroup-module__urgencynow___rwtZD`,
	"urgencyheld": `MemberGroup-module__urgencyheld___fHFCx`,
	"urgencysoon": `MemberGroup-module__urgencysoon___cbWAi`,
	"urgencyescalated": `MemberGroup-module__urgencyescalated___E5dUV`,
	"urgencylater": `MemberGroup-module__urgencylater___uHx_N`,
	"memberCell": `MemberGroup-module__memberCell____5a2N`,
	"memberNameLine": `MemberGroup-module__memberNameLine___hMuTf`,
	"memberName": `MemberGroup-module__memberName___DZis8`,
	"memberMrn": `MemberGroup-module__memberMrn___z6uQt`,
	"memberPhase": `MemberGroup-module__memberPhase___MmXCw`,
	"visitLine": `MemberGroup-module__visitLine___kSz5U`,
	"visitMark": `MemberGroup-module__visitMark___ff6r4`,
	"visitName": `MemberGroup-module__visitName___RbGHY`,
	"visitWhen": `MemberGroup-module__visitWhen___zvIvW`,
	"noVisit": `MemberGroup-module__noVisit___Qj2v_`,
	"countBadges": `MemberGroup-module__countBadges____mQTO`,
	"nowLater": `MemberGroup-module__nowLater___pX5Tm`,
	"nowPart": `MemberGroup-module__nowPart___PZQLP`,
	"laterPart": `MemberGroup-module__laterPart____pQfr`,
	"nowPartOn": `MemberGroup-module__nowPartOn___zqKYS`,
	"nowNumber": `MemberGroup-module__nowNumber___IZcYB`,
	"laterNumber": `MemberGroup-module__laterNumber___xLe6q`,
	"nowWord": `MemberGroup-module__nowWord___HvIrc`,
	"laterWord": `MemberGroup-module__laterWord___PWPUj`,
	"dueColumnUrgent": `MemberGroup-module__dueColumnUrgent___F3kvg`,
	"bucketIndexoverdue": `MemberGroup-module__bucketIndexoverdue___pPWXW`,
	"bucketIndexpriority": `MemberGroup-module__bucketIndexpriority___Yb9FA`,
	"bucketIndexfuture": `MemberGroup-module__bucketIndexfuture___w4GVj`,
	"bucketLabeloverdue": `MemberGroup-module__bucketLabeloverdue___IX4kj`,
	"bucketLabelpriority": `MemberGroup-module__bucketLabelpriority___QDuKf`,
	"countBadge": `MemberGroup-module__countBadge___eXufs`,
	"bucketHeader": `MemberGroup-module__bucketHeader___ylt7i`,
	"bucketCount": `MemberGroup-module__bucketCount___RYDRf`
};
module.exports = ___CSS_LOADER_EXPORT___;
